export type NavMenuItem = {
    readonly label: string;
    readonly href: string;
    readonly role?: readonly string[];
    readonly isHidden?: boolean;
    readonly public?: boolean;
    readonly activeUrls: readonly string[];
};

const navItems = [
    {
        label: 'Login',
        href: '/login',
        activeUrls: ['/login'],
        isHidden: true,
        public: true
    },
    {
        label: 'Dashboard',
        href: '/dashboard',
        activeUrls: ['/', '/dashboard']
    },
    {
        label: 'Admin',
        href: '/admin',
        activeUrls: ['/admin']
    },
    {
        label: 'Invoicing & Payroll',
        href: '/invoicing-payroll',
        activeUrls: ['/invoicing-payroll', '/invoicing-payroll/past-cycles']
    },
    {
        label: 'Reporting',
        href: '/reporting',
        role: ['admin', 'reporting'],
        activeUrls: ['/reporting']
    },
    {
        label: 'Search',
        href: '/search',
        role: ['user', 'admin', 'auditing'],
        activeUrls: ['/search']
    },
    {
        label: 'Configuration',
        href: '/configuration',
        role: ['admin'],
        activeUrls: ['/configuration']
    },
    {
        label: 'Support',
        href: '/support',
        activeUrls: ['/support'],
        public: true
    }
] as const satisfies readonly NavMenuItem[];

export type NavHref = (typeof navItems)[number]['href'];

export type NavMenuService = {
    getPublicNavItems: () => NavMenuItem[];
    getVisibleNavItems: () => NavMenuItem[];
    getNavItemByHref: (href: NavHref) => NavMenuItem | undefined;
    getRolesOfNavItem: (href: NavHref) => readonly string[] | undefined;
};

const navMenuService: NavMenuService = {
    getPublicNavItems: () => navItems.filter((m: NavMenuItem) => (m.public ? m.public : false)),
    getVisibleNavItems: () =>
        navItems.filter((n: NavMenuItem) => (n.isHidden ? n.isHidden !== true : true)),
    getNavItemByHref: (href: NavHref) => navItems.find((n) => n.href === href),
    getRolesOfNavItem(href: NavHref) {
        return this.getNavItemByHref(href)?.role;
    }
};

const publicNavItems = navMenuService.getPublicNavItems();
const visibleNavItems = navMenuService.getVisibleNavItems();

export { navMenuService, navItems as allNavItems, publicNavItems, visibleNavItems };
